<template>
  <v-card class="mb-3" style="border-radius: 10px;">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 pa-0 text-xs-left text-sm-right px-1>
          <div class="font-weight-thin">
            <span @click="downloadCsv" class="nowrap subtitle rounded-chip mr-3">
              Download CSV
            </span>
            Registros: {{ config.records.length }}
          </div>
        </v-flex>
        <scheduled-transaction :record="record" v-for="record in config.records" :key="record.id" @onAddBankTransaction="addBankTransaction" @onRemoveTransaction="removeTransaction"/>
        <form-dialog @onCreate="onCreate" :addBtn="false" :autocomplete="autocomplete" :dialog="dialog" :bankAccountReadOnly="true" @closeDialog="closeDialog"/>
      </v-layout>
    </v-container>
    <v-snackbar v-model="showSuccessSnackbar" :timeout="3000" color="#27DABC" class="custom-snackbar">
      {{ successMessage }}
    </v-snackbar>
    <v-card-actions>
      <v-layout column>
        <v-flex xs12>
          <v-btn v-if="showMoreBtn" block dark class="ma-0 btn-style" @click="requestMoreRecords">
            EXIBIR MAIS
          </v-btn>
          <v-btn v-if="config.selectable" block dark class="ma-0 btn-style--secondary mt-2" @click="selectableBtnClick" >
            {{config.selectable.btn_title}}
          </v-btn>
          <v-btn v-if="config.actionable" block dark class="ma-0 btn-style--tertiary mt-2" @click="actionableBtnClick" >
            {{config.actionable.btn_title}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import ScheduledBankTransactionItem from "./ScheduledBankTransactionItem"
import BankTransactionAddFormDialog from "./BankTransactionAddFormDialog"
import utils from "./shared/Utils"

export default {
  name: 'ScheduledBankTransactionList',
  components: {
    'scheduled-transaction': ScheduledBankTransactionItem,
    'form-dialog': BankTransactionAddFormDialog,
  },
  props: {
    config: {
      type: Object
    }
  },
  data() {
    return {
      filter: '',
      searchFilter: '',
      successMessage: "",
      showSuccessSnackbar: false,
      autocomplete: {
        value: '0',
        source_document_type: 'cpf',
        source_document_number: '',
        bank_account: null
      },
      dialog: false
    }
  },
  computed: {
    showMoreBtn() {
      if ((this.config.records.length > 0) && (this.config.records.length % this.config.perPage == 0)) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false
    },
    getLastRecordId() {
      let lastId = this.config.records.length - 1
      return this.config.records[lastId]['id']
    },
    requestMoreRecords(e) {
      if (this.config.loading == false) {
        this.$emit('loadMoreRecords', this.getLastRecordId())
      }
    },
    onCreate(created_record) {
      if (created_record.scheduled_bank_transaction_id != null) {
        this.config.records.splice(this.config.records.findIndex(el => el.id === created_record.scheduled_bank_transaction_id), 1)
      }
    },
    addBankTransaction(scheduled_bank_transaction) {
      this.autocomplete.source_document_type = scheduled_bank_transaction.source_document_type
      this.autocomplete.source_document_number = scheduled_bank_transaction.source_document_number
      this.autocomplete.value = scheduled_bank_transaction.value
      this.autocomplete.bank_account = scheduled_bank_transaction.from_bank_account
      this.dialog = true
    },
    selectableBtnClick() {
      this.config.selectable.btn_action()
    },
    actionableBtnClick() {
      this.config.actionable.btn_action()
    },
    removeTransaction(transactionId) {
      const index = this.config.records.findIndex(record => record.id === transactionId);

      if (index !== -1) {
      this.config.records.splice(index, 1);
      }

      this.successMessage = `Cancelamento da transação ID ${transactionId} realizado com sucesso!`;
      this.showSuccessSnackbar = true;
    },
    downloadCsv() {
      const header_line = [
        'DATE',
        'ID',
        'NAME',
        'DOCUMENT TYPE',
        'DOCUMENT',
        'CURRENCY',
        'TRANSACTION_VALUE',
        'EXCHANGE_CURRENCY',
        'EXCHANGE_VALUE',
        'STATUS',
        'ORIGIN_ACCOUNT',
        'DESTINATION_ACCOUNT',
        'OPERATION',
        'CANCELLATION_REASON',
        'REQUESTED_EXCHANGE',
        'REVERSE_EXCHANGE',
        'BANK_TRANSACTION_ID',
        'EXCHANGE_ID',
        'COMPANY_WIRE_ID',
        'DYNAMIC_PIX',
        'DYNAMIC_PIX_EXPIRATION_DATE',
        'BOLETO - BAR_CODE',
        'BOLETO - DIGITAL_LINE',
        'BOLETO - PDF_URL',
        'BOLETO - EXPIRATION_DATE',
        'OXXO - VALUE',
        'OXXO - DESCRIPTION',
        'OXXO - PDF_URL',
        'OXXO - EXPIRATION_DATE',
        'PSE - TICKET_ID',
        'PSE - UNIQUE_CODE',
        'PSE - AUTHORIZATION_ID',
        'PSE - BANK_CODE'
      ];

      const rows = this.config.records.reduce((rows, record) => {
        const insertedAt = utils.dbDateTimeToHuman(record.inserted_at);
        const subjectName = record.subject ? record.subject.social_name : '';
        const documentType = record.subject ? record.subject.document_type : '';
        const documentNumber = record.subject ? record.subject.document_number : '';
        const currency = record.currency || '';
        const exchangeCurrency = record.exchange_currency || '';
        const rawValue = record.value != null ? record.value : '';
        const rawExchangeValue = record.exchanged_value != null ? record.exchanged_value : '';
        let value, exchange_value;
        if (record.estimated_value_until_exchange) {
          if (record.value) {
            value = rawValue;
            exchange_value = rawExchangeValue;
          } else {
            value = currency;
            exchange_value = rawExchangeValue;
          }
        } else if (record.exchanged_value) {
          value = rawValue;
          exchange_value = rawExchangeValue;
        } else {
          value = rawValue;
          exchange_value = '';
        }
        const status = record.status;
        const fromAccount = record.from_bank_account
          ? (() => {
              const accountName = utils.longAccountName(record.from_bank_account);
              return accountName.includes(',') ? `"${accountName}"` : accountName;
            })()
          : 'Cartão de crédito';

        const toAccount = record.to_bank_account
          ? (() => {
              const accountName = utils.longAccountName(record.to_bank_account);
              return accountName.includes(',') ? `"${accountName}"` : accountName;
            })()
          : '';

        const isForExchange = record.for_exchange !== false;
        const isFromInternalAccount = record.from_bank_account && record.from_bank_account.internal === true;
        const isDepositToInternalAccount = record.to_bank_account && record.to_bank_account.internal === true;

        let operation = '';
        if (isForExchange) {
          if (!isDepositToInternalAccount && !isFromInternalAccount) {
            operation = `${record.company.social_name} solicitando conversão ${record.exchange_currency}`;
          } else if (!isDepositToInternalAccount && isFromInternalAccount) {
            operation = `${record.company.social_name} solicita conversão a partir de saldo em conta interna`;
          } else if (isDepositToInternalAccount && !isFromInternalAccount) {
            operation = `${record.company.social_name} solicita conversão para conta interna`;
          } else if (isDepositToInternalAccount && isFromInternalAccount) {
            operation = `${record.company.social_name} solicita conversão a partir de saldo em conta interna para conta interna`;
          }
        } else {
          if (!isDepositToInternalAccount && !isFromInternalAccount) {
            operation = `${record.company.social_name} solicitando transferência entre contas físicas sem conversão`;
          } else if (!isDepositToInternalAccount && isFromInternalAccount) {
            operation = `${record.company.social_name} solicitando pagamento a partir de saldo em conta interna sem conversão`;
          } else if (isDepositToInternalAccount && !isFromInternalAccount) {
            operation = `${record.company.social_name} solicitando depósito em conta interna sem conversão`;
          } else if (isDepositToInternalAccount && isFromInternalAccount) {
            operation = `${record.company.social_name} solicita transferência entre contas internas sem conversão`;
          }
        }

        const reasonCancelation = record.status === 'canceled' ? record.canceled_reason : '';

        const requestedExchange = record.exchange_under_request ? 'Sim' : 'Não';
        const revertedExchange = record.estimated_value_until_exchange ? 'Sim' : 'Não';

        const bankTransactionId = record.bank_transaction_id || (record.bank_transaction ? record.bank_transaction.id : '');
        const exchangeId = record.bank_transaction && record.bank_transaction.exchange_id ? record.bank_transaction.exchange_id : '';
        const companyWireId = record.bank_transaction && record.bank_transaction.wire_id ? record.bank_transaction.wire_id : '';

        const dinamicPix = record.dynamic_pix ? 'Sim' : 'Não';
        const expireDateDinamicPix = record.dynamic_pix_due_date || '';

        const boletoBarCode = record.boleto_info ? record.boleto_info.bar_code : '';
        const boletoDigitalLine = record.boleto_info ? record.boleto_info.digital_line : '';
        const boletoUrlPdf = record.boleto_info ? record.boleto_info.url_pdf : '';
        const boletoExpireDate = record.boleto_info ? record.boleto_info.expire_at : '';

        const oxxoValue = record.oxxo_info ? record.oxxo_info.amount : '';
        const oxxoDescription = record.oxxo_info ? record.oxxo_info.description : '';
        const oxxoUrlPdf = record.oxxo_info ? record.oxxo_info.url_pdf : '';
        const oxxoExpireDate = record.oxxo_info ? record.oxxo_info.expire_at : '';

        const pseTicketId = record.pse_info ? record.pse_info.ticket_id : '';
        const pseUnicCode = record.pse_info ? record.pse_info.trazability_code : '';
        const pseAuthorizationId = record.pse_info ? record.pse_info.authorization_id : '';
        const pseBankCode = record.pse_info ? record.pse_info.financial_institution_code : '';

        const row = [
          insertedAt,
          record.id,
          utils.parseCommaField(subjectName),
          documentType,
          utils.parseCommaField(documentNumber),
          currency,
          value,
          exchangeCurrency,
          exchange_value,
          status,
          fromAccount,
          toAccount,
          operation,
          utils.parseCommaField(reasonCancelation),
          requestedExchange,
          revertedExchange,
          bankTransactionId,
          exchangeId,
          companyWireId,
          dinamicPix,
          utils.dbDateTimeToHuman(expireDateDinamicPix),
          boletoBarCode,
          boletoDigitalLine,
          boletoUrlPdf,
          utils.dbDateTimeToHuman(boletoExpireDate),
          oxxoValue,
          oxxoDescription,
          oxxoUrlPdf,
          utils.dbDateTimeToHuman(oxxoExpireDate),
          pseTicketId,
          pseUnicCode,
          pseAuthorizationId,
          pseBankCode
        ];
        rows.push(row);
        return rows;
      }, [header_line]);

      utils.exportToCsv('scheduled_transactions_report.csv', rows, ';');
    },
  }
}
</script>
<style>
  .search-filter .v-icon {
    color: #CCC!important;
  }
  .search-filter .v-text-field__slot input {
    color: #AAA!important;
  }
</style>



// WEBPACK FOOTER //
// src/ScheduledBankTransactionList.vue